import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_sentence3mmsiuwjayd89 as get_sentence,
  get_displayName274cn1h5q1fsg as get_displayName,
  get_doesNotNeedLabel113kjiv7j7sfi as get_doesNotNeedLabel,
  visibility122l7g68ohruw as visibility,
  get_groupb5ywq6n1gjh5 as get_group,
} from './annotationReaders.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { lensPath2kkrykycsgvs9 as lensPath } from '../../serialization/MutableReactive.lens.DataClassPath.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  text1v7b2bj2gx49v as text,
  subtext2z3zzf0nosi4q as subtext,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance335jj07k1liay as Companion_getInstance_0 } from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import {
  set33aoyz3le40gz as set,
  getfcovrjca3cm8 as get,
} from './default.mjs';
import {
  get_annotations2g7n6lqltzfk6 as get_annotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_px1lajc6xaddk2r as get_px_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.js.mjs';
import {
  FormLayoutPreferences_Block_getInstance2bsp7v6nfhpj1 as FormLayoutPreferences_Block_getInstance,
  Companion_getInstance17fcxlkqs50ig as Companion_getInstance_1,
  FormSize383y0pj5845uy as FormSize,
} from './helpers.mjs';
import {
  FormSelector1zdq40oqbcvms as FormSelector,
  matches2uu672wulv59r as matches,
  Companion_instancegwok6qx7et5m as Companion_instance,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  priority7vn90mx06311 as priority,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  copyToArray2j022khrow2yi as copyToArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  indexOfa2zokh3tu4p6 as indexOf,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { CLASS_getInstance14ex35co4jkrb as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { MySealedClassSerializerInterface2tzma5kn4becp as MySealedClassSerializerInterface } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/MySealedClassSerializer.mjs';
import { CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { weightt34o7llf2uyq as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var FieldVisibility_HIDDEN_instance;
var FieldVisibility_READ_instance;
var FieldVisibility_EDIT_instance;
var FieldVisibility_entriesInitialized;
function FieldVisibility_initEntries() {
  if (FieldVisibility_entriesInitialized)
    return Unit_instance;
  FieldVisibility_entriesInitialized = true;
  FieldVisibility_HIDDEN_instance = FieldVisibility().ydr('HIDDEN', 0);
  FieldVisibility_READ_instance = FieldVisibility().ydr('READ', 1);
  FieldVisibility_EDIT_instance = FieldVisibility().ydr('EDIT', 2);
}
var FieldVisibilityClass;
function FieldVisibility() {
  if (FieldVisibilityClass === VOID) {
    class $ extends Enum() {
      static ydr(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'FieldVisibility');
    FieldVisibilityClass = $;
  }
  return FieldVisibilityClass;
}
var SubClass;
function Sub() {
  if (SubClass === VOID) {
    class $ {
      constructor($outer, field, form, view) {
        this.eds_1 = $outer;
        this.zdr_1 = field;
        this.ads_1 = form;
        this.bds_1 = view;
        var tmp = this;
        var tmp0_safe_receiver = get_sentence(this.zdr_1);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = this.ads_1.p1().jds(this.ads_1.p1().fds_1 + (imul(tmp0_safe_receiver.length, 3) / 4 | 0));
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp.cds_1 = tmp1_elvis_lhs == null ? this.ads_1.p1().jds(this.ads_1.p1().fds_1) : tmp1_elvis_lhs;
        var tmp_1 = this;
        var tmp0_safe_receiver_0 = get_sentence(this.zdr_1);
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = this.bds_1.p1().jds(this.bds_1.p1().fds_1 + (imul(tmp0_safe_receiver_0.length, 3) / 4 | 0));
        }
        var tmp1_elvis_lhs_0 = tmp_2;
        tmp_1.dds_1 = tmp1_elvis_lhs_0 == null ? this.bds_1.p1().jds(this.bds_1.p1().fds_1) : tmp1_elvis_lhs_0;
      }
      kds(writer, mutable) {
        var w = lensPath(mutable, new (DataClassPathAccess())(new (DataClassPathSelf())(this.eds_1.mds_1), this.zdr_1));
        if (visibility(this.zdr_1, this.eds_1.lds_1).equals(FieldVisibility_READ_getInstance())) {
          // Inline function 'com.lightningkite.kiteui.forms.Sub.f' call
          // Inline function 'kotlin.with' call
          var tmp;
          if (this.bds_1.uds() || get_doesNotNeedLabel(this.zdr_1)) {
            this.bds_1.tds()(writer, this.zdr_1, w);
            tmp = Unit_instance;
          } else {
            var tmp0_safe_receiver = get_sentence(this.zdr_1);
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              var before = substringBefore(tmp0_safe_receiver, _Char___init__impl__6a9atx(95));
              var after = substringAfter(tmp0_safe_receiver, _Char___init__impl__6a9atx(95));
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RowOrCol())(writer.pc());
              var tmp0_elvis_lhs = writer.cbb_1;
              var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
              writer.ebb(p, view);
              view.xbm(false);
              view.zb8(get_rem(0.3));
              // Inline function 'kotlin.text.isNotBlank' call
              if (!isBlank(before)) {
                view.jbb(get_centered(view), text(view, before));
              }
              get_centered(view);
              this.bds_1.tds()(view, this.zdr_1, w);
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
              Companion_getInstance();
              // Inline function 'kotlin.text.isNotBlank' call
              if (!isBlank(after)) {
                view.jbb(get_centered(view), text(view, after));
              }
              writer.fbb(p, view);
              tmp_0 = view;
            }
            var tmp1_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (RowOrCol())(writer.pc());
              var tmp0_elvis_lhs_0 = writer.cbb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? writer : tmp0_elvis_lhs_0;
              writer.ebb(p_0, view_0);
              view_0.xbm(true);
              view_0.zb8(get_px(0));
              subtext(view_0, get_displayName(this.zdr_1));
              this.bds_1.tds()(view_0, this.zdr_1, w);
              writer.fbb(p_0, view_0);
              tmp_1 = view_0;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }
            tmp = tmp_1;
          }
        } else {
          // Inline function 'com.lightningkite.kiteui.forms.Sub.f' call
          // Inline function 'kotlin.with' call
          var tmp_2;
          if (this.ads_1.uds() || get_doesNotNeedLabel(this.zdr_1)) {
            this.ads_1.tds()(writer, this.zdr_1, w);
            tmp_2 = Unit_instance;
          } else {
            var tmp0_safe_receiver_0 = get_sentence(this.zdr_1);
            var tmp_3;
            if (tmp0_safe_receiver_0 == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var before_0 = substringBefore(tmp0_safe_receiver_0, _Char___init__impl__6a9atx(95));
              var after_0 = substringAfter(tmp0_safe_receiver_0, _Char___init__impl__6a9atx(95));
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_1 = new (RowOrCol())(writer.pc());
              var tmp0_elvis_lhs_1 = writer.cbb_1;
              var p_1 = tmp0_elvis_lhs_1 == null ? writer : tmp0_elvis_lhs_1;
              writer.ebb(p_1, view_1);
              view_1.xbm(false);
              view_1.zb8(get_rem(0.3));
              // Inline function 'kotlin.text.isNotBlank' call
              if (!isBlank(before_0)) {
                view_1.jbb(get_centered(view_1), text(view_1, before_0));
              }
              get_centered(view_1);
              this.ads_1.tds()(view_1, this.zdr_1, w);
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
              Companion_getInstance();
              // Inline function 'kotlin.text.isNotBlank' call
              if (!isBlank(after_0)) {
                view_1.jbb(get_centered(view_1), text(view_1, after_0));
              }
              writer.fbb(p_1, view_1);
              tmp_3 = view_1;
            }
            var tmp1_elvis_lhs_0 = tmp_3;
            var tmp_4;
            if (tmp1_elvis_lhs_0 == null) {
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_2 = new (RowOrCol())(writer.pc());
              var tmp0_elvis_lhs_2 = writer.cbb_1;
              var p_2 = tmp0_elvis_lhs_2 == null ? writer : tmp0_elvis_lhs_2;
              writer.ebb(p_2, view_2);
              view_2.xbm(true);
              view_2.zb8(get_px(0));
              subtext(view_2, get_displayName(this.zdr_1));
              this.ads_1.tds()(view_2, this.zdr_1, w);
              writer.fbb(p_2, view_2);
              tmp_4 = view_2;
            } else {
              tmp_4 = tmp1_elvis_lhs_0;
            }
            tmp_2 = tmp_4;
          }
        }
      }
      vds(writer, readable) {
        var r = lens(readable, (it) => this.zdr_1.m2j(it));
        // Inline function 'com.lightningkite.kiteui.forms.Sub.f' call
        // Inline function 'kotlin.with' call
        var tmp;
        if (this.bds_1.uds() || get_doesNotNeedLabel(this.zdr_1)) {
          this.bds_1.tds()(writer, this.zdr_1, r);
          tmp = Unit_instance;
        } else {
          var tmp0_safe_receiver = get_sentence(this.zdr_1);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var before = substringBefore(tmp0_safe_receiver, _Char___init__impl__6a9atx(95));
            var after = substringAfter(tmp0_safe_receiver, _Char___init__impl__6a9atx(95));
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())(writer.pc());
            var tmp0_elvis_lhs = writer.cbb_1;
            var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
            writer.ebb(p, view);
            view.xbm(false);
            view.zb8(get_rem(0.3));
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(before)) {
              view.jbb(get_centered(view), text(view, before));
            }
            get_centered(view);
            this.bds_1.tds()(view, this.zdr_1, r);
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
            Companion_getInstance();
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(after)) {
              view.jbb(get_centered(view), text(view, after));
            }
            writer.fbb(p, view);
            tmp_0 = view;
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (RowOrCol())(writer.pc());
            var tmp0_elvis_lhs_0 = writer.cbb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? writer : tmp0_elvis_lhs_0;
            writer.ebb(p_0, view_0);
            view_0.xbm(true);
            view_0.zb8(get_px(0));
            subtext(view_0, get_displayName(this.zdr_1));
            this.bds_1.tds()(view_0, this.zdr_1, r);
            writer.fbb(p_0, view_0);
            tmp_1 = view_0;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          tmp = tmp_1;
        }
      }
    }
    initMetadataForClass($, 'Sub');
    SubClass = $;
  }
  return SubClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.wds_1 = function_0;
      }
      wi(a, b) {
        return this.wds_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.wds_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.xds_1 = function_0;
      }
      wi(a, b) {
        return this.xds_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.xds_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
var ByFieldRenderer$TypeInfo$bestPropertiesAttempt$1Class;
function ByFieldRenderer$TypeInfo$bestPropertiesAttempt$1() {
  if (ByFieldRenderer$TypeInfo$bestPropertiesAttempt$1Class === VOID) {
    class $ {
      constructor($serializer, $index, $it) {
        this.bdt_1 = $serializer;
        this.cdt_1 = $index;
        this.ddt_1 = $it;
        this.yds_1 = $serializer.az().v11($index);
        var tmp = this;
        tmp.zds_1 = isInterface($it, KSerializer()) ? $it : THROW_CCE();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = $serializer.az().x11($index);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = Companion_getInstance_0().q4r(element);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.v(tmp0_safe_receiver);
          }
        }
        tmp_0.adt_1 = destination;
      }
      k20() {
        return this.yds_1;
      }
      j2j() {
        return this.zds_1;
      }
      edt(receiver, value) {
        var tmp = this.bdt_1;
        var tmp_0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var tmp_1 = this.ddt_1;
        return set(tmp_0, receiver, this.cdt_1, isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE(), value);
      }
      p2j(receiver, value) {
        var tmp = (receiver == null ? true : !(receiver == null)) ? receiver : THROW_CCE();
        return this.edt(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      fdt(receiver) {
        var tmp = this.bdt_1;
        return get(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE(), receiver, this.cdt_1, this.ddt_1);
      }
      m2j(receiver) {
        return this.fdt((receiver == null ? true : !(receiver == null)) ? receiver : THROW_CCE());
      }
      q2j() {
        return this.adt_1;
      }
    }
    protoOf($).bz = get_annotations;
    initMetadataForClass($, VOID, VOID, VOID, [SerializableProperty()]);
    ByFieldRenderer$TypeInfo$bestPropertiesAttempt$1Class = $;
  }
  return ByFieldRenderer$TypeInfo$bestPropertiesAttempt$1Class;
}
var TypeInfoClass;
function TypeInfo() {
  if (TypeInfoClass === VOID) {
    class $ {
      constructor(module_0, serializer, availableWidth) {
        availableWidth = availableWidth === VOID ? get_px_0(AppState_getInstance().mbi().f2().ebi_1) / get_px_0(get_rem_0(1)) : availableWidth;
        this.lds_1 = module_0;
        this.mds_1 = serializer;
        this.nds_1 = availableWidth;
        var tmp = this;
        var tmp0_elvis_lhs = get_serializableProperties(this.mds_1);
        // Inline function 'kotlin.collections.map' call
        var this_0 = tmp0_elvis_lhs == null ? this.gdt() : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(this_0.length);
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var item = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp_0 = new (FormSelector())(item.j2j(), item.q2j(), FormLayoutPreferences_Block_getInstance());
          var sel = tmp_0 instanceof FormSelector() ? tmp_0 : THROW_CCE();
          var tmp$ret$0 = new (Sub())(this, isInterface(item, SerializableProperty()) ? item : THROW_CCE(), this.lds_1.ydt(sel), this.lds_1.zdt(sel));
          destination.v(tmp$ret$0);
        }
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s = destination.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!visibility(element.zdr_1, this.lds_1).equals(FieldVisibility_HIDDEN_getInstance())) {
            destination_0.v(element);
          }
        }
        tmp.ods_1 = destination_0;
        var tmp_1 = this;
        // Inline function 'kotlin.run' call
        var $this$run = this;
        var used = HashSet().ha();
        var grouped = ArrayList().w();
        // Inline function 'kotlin.collections.groupBy' call
        var tmp0 = $this$run.ods_1;
        // Inline function 'kotlin.collections.groupByTo' call
        var destination_1 = LinkedHashMap().f6();
        var _iterator__ex2g4s_0 = tmp0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var key = get_group(element_0.zdr_1);
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination_1.p3(key);
          var tmp_2;
          if (value == null) {
            var answer = ArrayList().w();
            destination_1.s3(key, answer);
            tmp_2 = answer;
          } else {
            tmp_2 = value;
          }
          var list = tmp_2;
          list.v(element_0);
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_1 = destination_1.d2().m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          // Inline function 'kotlin.collections.component1' call
          var group = element_1.e2();
          // Inline function 'kotlin.collections.component2' call
          var fields = element_1.f2();
          // Inline function 'kotlin.collections.plusAssign' call
          addAll(used, fields);
          // Inline function 'kotlin.collections.plusAssign' call
          grouped.v(fields);
        }
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_2 = ArrayList().w();
        var _iterator__ex2g4s_2 = grouped.m1();
        while (_iterator__ex2g4s_2.n1()) {
          var element_2 = _iterator__ex2g4s_2.o1();
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_3 = ArrayList().u(collectionSizeOrDefault(element_2, 10));
          var _iterator__ex2g4s_3 = element_2.m1();
          while (_iterator__ex2g4s_3.n1()) {
            var item_0 = _iterator__ex2g4s_3.o1();
            var tmp$ret$18 = listOf(item_0);
            destination_3.v(tmp$ret$18);
          }
          var list_0 = destination_3;
          addAll(destination_2, list_0);
        }
        // Inline function 'kotlin.collections.sortedBy' call
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_3 = (a, b) => {
          // Inline function 'kotlin.comparisons.compareValuesBy' call
          var tmp = indexOf($this$run.ods_1, a.q1(0));
          var tmp$ret$25 = indexOf($this$run.ods_1, b.q1(0));
          return compareValues(tmp, tmp$ret$25);
        };
        var tmp$ret$27 = new (sam$kotlin_Comparator$0())(tmp_3);
        tmp_1.pds_1 = sortedWith(destination_2, tmp$ret$27);
        var tmp_4 = this;
        // Inline function 'kotlin.run' call
        var $this$run_0 = this;
        var used_0 = HashSet().ha();
        var grouped_0 = ArrayList().w();
        // Inline function 'kotlin.collections.groupBy' call
        var tmp0_0 = $this$run_0.ods_1;
        // Inline function 'kotlin.collections.groupByTo' call
        var destination_4 = LinkedHashMap().f6();
        var _iterator__ex2g4s_4 = tmp0_0.m1();
        while (_iterator__ex2g4s_4.n1()) {
          var element_3 = _iterator__ex2g4s_4.o1();
          var key_0 = get_group(element_3.zdr_1);
          // Inline function 'kotlin.collections.getOrPut' call
          var value_0 = destination_4.p3(key_0);
          var tmp_5;
          if (value_0 == null) {
            var answer_0 = ArrayList().w();
            destination_4.s3(key_0, answer_0);
            tmp_5 = answer_0;
          } else {
            tmp_5 = value_0;
          }
          var list_1 = tmp_5;
          list_1.v(element_3);
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_5 = destination_4.d2().m1();
        while (_iterator__ex2g4s_5.n1()) {
          var element_4 = _iterator__ex2g4s_5.o1();
          // Inline function 'kotlin.collections.component1' call
          var group_0 = element_4.e2();
          // Inline function 'kotlin.collections.component2' call
          var fields_0 = element_4.f2();
          // Inline function 'kotlin.collections.plusAssign' call
          addAll(used_0, fields_0);
          // Inline function 'kotlin.collections.plusAssign' call
          grouped_0.v(fields_0);
        }
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_5 = ArrayList().w();
        var _iterator__ex2g4s_6 = grouped_0.m1();
        while (_iterator__ex2g4s_6.n1()) {
          var element_5 = _iterator__ex2g4s_6.o1();
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_6 = ArrayList().u(collectionSizeOrDefault(element_5, 10));
          var _iterator__ex2g4s_7 = element_5.m1();
          while (_iterator__ex2g4s_7.n1()) {
            var item_1 = _iterator__ex2g4s_7.o1();
            var tmp$ret$43 = listOf(item_1);
            destination_6.v(tmp$ret$43);
          }
          var list_2 = destination_6;
          addAll(destination_5, list_2);
        }
        // Inline function 'kotlin.collections.sortedBy' call
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_6 = (a, b) => {
          // Inline function 'kotlin.comparisons.compareValuesBy' call
          var tmp = indexOf($this$run_0.ods_1, a.q1(0));
          var tmp$ret$50 = indexOf($this$run_0.ods_1, b.q1(0));
          return compareValues(tmp, tmp$ret$50);
        };
        var tmp$ret$52 = new (sam$kotlin_Comparator$0_0())(tmp_6);
        tmp_4.qds_1 = sortedWith(destination_5, tmp$ret$52);
        var tmp_7 = this;
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_8 = this.pds_1.m1();
        while (_iterator__ex2g4s_8.n1()) {
          var element_6 = _iterator__ex2g4s_8.o1();
          var tmp_8 = sum;
          var tmp$ret$56;
          $l$block: {
            // Inline function 'kotlin.collections.maxOfOrNull' call
            var iterator = element_6.m1();
            if (!iterator.n1()) {
              tmp$ret$56 = null;
              break $l$block;
            }
            var maxValue = iterator.o1().cds_1.gds_1;
            while (iterator.n1()) {
              var v = iterator.o1().cds_1.gds_1;
              // Inline function 'kotlin.comparisons.maxOf' call
              var a = maxValue;
              maxValue = Math.max(a, v);
            }
            tmp$ret$56 = maxValue;
          }
          var tmp0_elvis_lhs_0 = tmp$ret$56;
          sum = tmp_8 + (tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0);
        }
        tmp_7.rds_1 = sum;
        var tmp_9 = this;
        // Inline function 'kotlin.collections.sumOf' call
        var sum_0 = 0;
        var _iterator__ex2g4s_9 = this.qds_1.m1();
        while (_iterator__ex2g4s_9.n1()) {
          var element_7 = _iterator__ex2g4s_9.o1();
          var tmp_10 = sum_0;
          var tmp$ret$62;
          $l$block_0: {
            // Inline function 'kotlin.collections.maxOfOrNull' call
            var iterator_0 = element_7.m1();
            if (!iterator_0.n1()) {
              tmp$ret$62 = null;
              break $l$block_0;
            }
            var maxValue_0 = iterator_0.o1().dds_1.gds_1;
            while (iterator_0.n1()) {
              var v_0 = iterator_0.o1().dds_1.gds_1;
              // Inline function 'kotlin.comparisons.maxOf' call
              var a_0 = maxValue_0;
              maxValue_0 = Math.max(a_0, v_0);
            }
            tmp$ret$62 = maxValue_0;
          }
          var tmp0_elvis_lhs_1 = tmp$ret$62;
          sum_0 = tmp_10 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
        }
        tmp_9.sds_1 = sum_0;
      }
      gdt() {
        var serializer = this.mds_1;
        if (isInterface(serializer, GeneratedSerializer())) {
          // Inline function 'kotlin.collections.mapIndexed' call
          var this_0 = serializer.t1b();
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var destination = ArrayList().u(this_0.length);
          var index = 0;
          var inductionVariable = 0;
          var last = this_0.length;
          while (inductionVariable < last) {
            var item = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var tmp$ret$0 = new (ByFieldRenderer$TypeInfo$bestPropertiesAttempt$1())(serializer, _unary__edvuaz, item);
            destination.v(tmp$ret$0);
          }
          // Inline function 'kotlin.collections.toTypedArray' call
          return copyToArray(destination);
        }
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [];
      }
    }
    initMetadataForClass($, 'TypeInfo');
    TypeInfoClass = $;
  }
  return TypeInfoClass;
}
var ByFieldRendererClass;
function ByFieldRenderer() {
  if (ByFieldRendererClass === VOID) {
    class $ {
      constructor() {
        ByFieldRenderer_instance = this;
        this.adu_1 = 'By Field';
        this.bdu_1 = CLASS_getInstance();
      }
      k20() {
        return this.adu_1;
      }
      cdu() {
        return 0.7;
      }
      s11() {
        return this.bdu_1;
      }
      ddu(module_0, selector) {
        if (selector.edu_1.az().t11())
          return false;
        var tmp = selector.edu_1;
        if (isInterface(tmp, MySealedClassSerializerInterface()))
          return false;
        return matches.call(this, module_0, selector) && !selector.edu_1.az().l11();
      }
      idu(module_0, selector) {
        var info = new (TypeInfo())(module_0, selector.edu_1);
        return new (FormSize())(Companion_getInstance_1().kdu_1.fds_1, info.sds_1);
      }
      ldu(module_0, selector) {
        var info = new (TypeInfo())(module_0, selector.edu_1);
        var tmp = Companion_instance;
        return tmp.mdu(module_0, this, selector, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          var tmp;
          if (!(field == null)) {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            $this$FormRenderer.hbb(CardSemantic_getInstance());
            tmp = Unit_instance;
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          view.xbm(true);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = info.pds_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.p1() === 1) {
              element.q1(0).kds(view, mutable);
            } else {
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (RowOrCol())(view.pc());
              var tmp0_elvis_lhs_0 = view.cbb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
              view.ebb(p_0, view_0);
              view_0.xbm(false);
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_0 = element.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                weight(view_0, element_0.cds_1.fds_1);
                element_0.kds(view_0, mutable);
              }
              view.fbb(p_0, view_0);
            }
          }
          $this$FormRenderer.fbb(p, view);
          return view;
        });
      }
      ndu(module_0, selector) {
        var info = new (TypeInfo())(module_0, selector.edu_1);
        var tmp = Companion_instance_0;
        return tmp.odu(module_0, this, selector, VOID, VOID, ($this$ViewRenderer, field, readable) => {
          var tmp;
          if (!(field == null)) {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            $this$ViewRenderer.hbb(CardSemantic_getInstance());
            tmp = Unit_instance;
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.ebb(p, view);
          view.xbm(true);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = info.qds_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.p1() === 1) {
              element.q1(0).vds(view, readable);
            } else {
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (RowOrCol())(view.pc());
              var tmp0_elvis_lhs_0 = view.cbb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
              view.ebb(p_0, view_0);
              view_0.xbm(false);
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_0 = element.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                weight(view_0, element_0.dds_1.fds_1);
                element_0.vds(view_0, readable);
              }
              view.fbb(p_0, view_0);
            }
          }
          $this$ViewRenderer.fbb(p, view);
          return view;
        });
      }
    }
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    initMetadataForObject($, 'ByFieldRenderer', VOID, VOID, [Generator(), Generator_0()]);
    ByFieldRendererClass = $;
  }
  return ByFieldRendererClass;
}
var ByFieldRenderer_instance;
function ByFieldRenderer_getInstance() {
  if (ByFieldRenderer_instance === VOID)
    new (ByFieldRenderer())();
  return ByFieldRenderer_instance;
}
function FieldVisibility_HIDDEN_getInstance() {
  FieldVisibility_initEntries();
  return FieldVisibility_HIDDEN_instance;
}
function FieldVisibility_READ_getInstance() {
  FieldVisibility_initEntries();
  return FieldVisibility_READ_instance;
}
function FieldVisibility_EDIT_getInstance() {
  FieldVisibility_initEntries();
  return FieldVisibility_EDIT_instance;
}
//region block: exports
export {
  FieldVisibility_EDIT_getInstance as FieldVisibility_EDIT_getInstance3hsitptq9f6o8,
  FieldVisibility_HIDDEN_getInstance as FieldVisibility_HIDDEN_getInstancehi7nnl1vgjal,
  FieldVisibility_READ_getInstance as FieldVisibility_READ_getInstance176iysh3c9pdi,
  ByFieldRenderer_getInstance as ByFieldRenderer_getInstancew6mhcnruubzr,
};
//endregion

//# sourceMappingURL=ByFieldRenderer.mjs.map
